import React from 'react'
import SubHeader from '../components/SubHeader'

const Projects = () => {
  return (
    <>
    <SubHeader />
      <h1>Projects Page</h1>
    </>
  )
}

export default Projects
